import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getPublicMarketingPage } from '../api/client';
import MarketingPageView from '../components/MarketingPageView';
import LoadingLeaf from '../components/LoadingLeaf';

// Public, unauthenticated route — no PrivateRoute, no useAuth() gate, same
// pattern as the client portal's /portal/:accessCode routes.
export default function PublicMarketingPage() {
    const { slug } = useParams();
    const [page, setPage] = useState(null);
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPublicMarketingPage(slug)
            .then(res => setPage(res.data))
            .catch(() => setNotFound(true))
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) {
        return <div style={styles.centered}><LoadingLeaf size={64} /></div>;
    }

    if (notFound || !page) {
        return (
            <div style={styles.centered}>
                <div style={styles.notFoundTitle}>This page isn't available.</div>
                <div style={styles.notFoundText}>It may have been unpublished, or the address is incorrect.</div>
            </div>
        );
    }

    return <MarketingPageView page={page} />;
}

const styles = {
    centered: { minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif", color: 'var(--text-dark)', background: 'var(--cream)', padding: '20px', textAlign: 'center' },
    notFoundTitle: { fontFamily: "'Lora', Georgia, serif", fontSize: '22px', marginBottom: '8px' },
    notFoundText: { fontSize: '14px', color: 'var(--text-soft)' },
};
